import { formatNumber, getCurrencySymbol } from '@angular/common';
import { LOCALE_ID, Pipe, PipeTransform, inject } from '@angular/core';

// Price formatting from Zero Web
@Pipe({
  name: 'priceScale',
  standalone: true,
})
export class PriceScalePipe implements PipeTransform {
  readonly #localId = inject(LOCALE_ID);

  public transform(
    value: number,
    priceScale?: number,
    withoutSymbol = false,
    currencyCode?: string,
  ): string {
    if (value === undefined) {
      return '';
    }

    priceScale = priceScale ?? 2;
    const digitsInfo = `1.${priceScale}-${priceScale}`;

    if (withoutSymbol) {
      return formatNumber(value, this.#localId, digitsInfo);
    }

    const currencySymbol = currencyCode ? getCurrencySymbol(currencyCode, 'narrow') : '€';
    return `${formatNumber(value, this.#localId, digitsInfo)}\u00A0${currencySymbol}`;
  }
}
